import React from 'react'
import TasksCounter from './TasksCounter'
import AssociatedTasks from './AssociatedTasks'
import HelpfulnessCheck from './HelpfulnessCheck'
import ShowFileLists from '../../schedules/common_components/ShowFileLists'

class ItemView extends React.Component {
  timelineItems() {
    return this.props.data.timeline_items;
  }

  itemImage() {
    return { backgroundImage: `url(${this.props.data.image_url})` };
  }

  componentDidMount() {
    this.buildIframe();
  }

  componentDidUpdate() {
    this.buildIframe();
  }

  pendingBenefitText() {
    if (this.props.data.pending) {
      return gon.company_variables.pending_benefit_instructions;
    } else {
      return '';
    }
  }

  handleDownloadFile(itemFileId) {
    const timeline_id = this.props.data.timeline_id
    const href = `<a href='/timeline_items/${timeline_id}/download_file?item_file_id=${itemFileId}' />`
    const url = $.parseHTML(href)[0]
    url.trigger('click')
  }

  buildIframe() {
    const content = !this.props.description || (this.props.description.length === 0) ? `<br>` : this.props.description;
    const baseUrl = `${window.location.protocol}//${window.location.host}`;
    let headHtml = '';
    headHtml += `<link type="text/css" rel="stylesheet" href=${baseUrl}/assets/skins/content/default/content.min.css>`;
    headHtml += `<link type="text/css" rel="stylesheet" href=${baseUrl}/assets/plugins/a11ychecker/css/annotations.css>`;
    headHtml += `<link type="text/css" rel="stylesheet" href=${baseUrl}/assets/plugins/mediaembed/content.min.css>`;
    headHtml += `<link type="text/css" rel="stylesheet" href=${baseUrl}/assets/plugins/linkchecker/content.min.css>`;
    headHtml += `<link type="text/css" rel="stylesheet" href=${baseUrl}/assets/custom_tinymce.css>`;
    headHtml += `<link type="text/css" rel="stylesheet" href=${baseUrl}/assets/graphik.css>`;
    const bodyClass = '';
    const preventClicksOnLinksScript = `<script>document.addEventListener && document.addEventListener("click", function(e) {for (var elm = e.target; elm; elm = elm.parentNode) {if (elm.nodeName === "A") {e.preventDefault(); window.open(elm.href);}}}, false);</script> `;
    const collapseableScript = `<script>
      function resizeContainer(iframe) {
        body = iframe.contentWindow.document.body
        iframe.style.height = body.scrollHeight + 50 + "px";
      };
      function toggleCollapsableDiv(hideNode) {
        var div = hideNode.parentElement.parentElement.querySelector(".tinymce-template-collapsing-div");
        if (div.style.display == "none") {
          div.style.display = "";
          hideNode.textContent = "Hide";
        } else {
          div.style.display = "none";
          hideNode.textContent = "Show";
        }
      };
      if (document.addEventListener) {
        var selectors = document.querySelectorAll(".tinymce-template-collapsing-button");
        for (var i=0; i < selectors.length; i++) {
          toggleCollapsableDiv(selectors[i]);
          selectors[i].addEventListener("click", function(e) {
            var element = e.target;
            toggleCollapsableDiv(element)
            resizeContainer(window.frameElement)
          });
        }
      }
    </script> `
    const iframeBody = `<!DOCTYPE html><html><head>${headHtml}</head><body id="tinymce" class="mce-content-body description-preview">${this.pendingBenefitText()}${_getDescription(content)}${preventClicksOnLinksScript}${collapseableScript}</body></html>`;
    const iframe = document.createElement('iframe');
    iframe.setAttribute('class', 'iframe-modal benefit-detail resizable-iframe');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('scrolling', 'no');
    const iframe_description = $('.item-detail-description-view')[0];
    iframe_description.innerHTML = '';
    iframe_description.appendChild(iframe);
    iframe.contentWindow.document.open();
    iframe.contentWindow.document.write(iframeBody);
    iframe.contentWindow.document.close();
    setTimeout((() => resizeIframe()), 100);
  }

  renderItemFiles() {
    if (this.props.itemFiles) {
      return (
        <ShowFileLists
          itemFiles={this.props.itemFiles}
          downloadItemFile={this.handleDownloadFile.bind(this)}
        />
      )
    }
  }

  renderAssociatedTasks() {
    if (this.props.associationUrl) {
      return (
        <AssociatedTasks
          data={this.props.data}
          updateRecord={this.props.updateRecord}
          associationUrl={this.props.associationUrl}
          handleCheck={this.props.handleCheck}
          onHelpfulCheck={this.props.onHelpfulCheck}
          just_looking={this.props.just_looking}
          handleJustLookingClick={this.props.handleJustLookingClick}
          isLeavePlanPartner={this.props.isLeavePlanPartner}
        />
      )
    }
  }

  renderHelpfulnessCheck() {
    if (!this.props.isLeavePlanPartner) {
      return (
        <div className='helpfulness-area'>
          <HelpfulnessCheck
            item={this.props.data.item}
            item_type={this.props.data.item_type}
            onHelpfulCheck={this.props.onHelpfulCheckFromOutside}
            isLeavePlanPartner={this.props.isLeavePlanPartner}
          />
        </div>
      )
    }
  }
  renderTaskTitle() {
    if (this.props.data.timeline_items) {
      let hoursUsageButton, taskCounter

      if (this.props.data.time_off_enabled) {
        hoursUsageButton = (<a className='btn btn-primary std-refill-button' href="/employees/std_time_off_balances">
          Update Hours Usage
        </a>)
      }

      if (this.timelineItems().length) {
        taskCounter = <TasksCounter tasksCount={this.timelineItems().length} />
      }

      return (
        <div className='row'>
          <div className='col-md-12 content-header tasks-counter'>
            <h3>
              {this.props.data.title}
              {hoursUsageButton}
              {taskCounter}
            </h3>
          </div>
        </div>
      )
    }
  }

  render() {
    return (
      <div>
        <div className='row benefit-content'>
          <div className='col-md-10'>
            <div className='row'>
              <div className='back-to-list' onClick={this.props.handleBackClick}>
                <i className='fa fa-chevron-left' />
                <i className='fa fa-chevron-left'>Back</i>
              </div>
            </div>
            {this.renderTaskTitle()}
          </div>
          <div className='col-md-2'>
            <div className='leave-item-logo' style={this.itemImage()} />
          </div>
          <div className="col-md-12 item-detail-description-view" />
          {this.renderItemFiles()}
          {this.renderAssociatedTasks()}
          {this.renderHelpfulnessCheck()}
        </div>
      </div>
    )
  }
}

export default ItemView
